<template>
  <!-- 앱 전역 난수 미입력 안내 배너 (SPEC-CHINA-GLOBAL-RANDOMNO-BANNER-001).
       ManualWorkOrders.vue 화면 자체는 동일 정보를 자기 배너로 이미 보여주므로 이중 노출을 막는다. -->
  <a-alert
    v-if="visible"
    type="warning"
    banner
    show-icon
    class="global-missing-randomno-banner"
  >
    <template #message>
      {{ message }}
    </template>
    <template #action>
      <a-button type="primary" size="small" @click="goFill">
        {{ $t('globalMissingRandomNo_action_btn') }}
      </a-button>
    </template>
  </a-alert>
</template>

<script>
export default {
  name: 'GlobalMissingRandomNoBanner',

  computed: {
    // App.vue isCustomPage와 동일 판정 — 로그인 화면 등은 셸이 없어 배너도 없어야 한다.
    isCustomPage() {
      const specialRoutes = ['/mobile', '/signin'];
      return specialRoutes.includes(this.$route.path.toLowerCase());
    },
    hasToken() {
      return !!localStorage.getItem('accessTokenManu');
    },
    // 셸 안에서 렌더되지만 배너를 띄우면 안 되는 화면(강제 비번변경, 비번 재설정, 메뉴 없음).
    isExcludedPath() {
      const excluded = ['/force-password-change', '/reset-pwd', '/no-menu'];
      return excluded.includes(this.$route.path.toLowerCase());
    },
    // 수기 작업지시서 목록 화면은 자체 배너를 이미 갖고 있어 전역 배너를 숨긴다.
    isManualWorkOrdersRoute() {
      return this.$route.name === 'ManualWorkOrders';
    },
    count() {
      return this.$store.state.missingRandomNo.count;
    },
    eligible() {
      return this.$store.state.missingRandomNo.eligible;
    },
    truncated() {
      return this.$store.state.missingRandomNo.truncated;
    },
    visible() {
      return (
        !this.isCustomPage
        && this.hasToken
        && !this.isExcludedPath
        && !this.isManualWorkOrdersRoute
        && this.eligible
        && this.count > 0
      );
    },
    message() {
      const key = this.truncated
        ? 'globalMissingRandomNo_message_truncated'
        : 'globalMissingRandomNo_message';
      return this.$t(key, { count: this.count });
    },
  },

  watch: {
    // ManualWorkOrders 화면을 "벗어날 때"만 재조회한다 — 방금 마친 난수 입력 작업이
    // 카운트에 즉시 반영되게 하되, 매 라우트 변경마다 불필요하게 재호출하지 않는다.
    '$route.name'(newName, oldName) {
      if (oldName === 'ManualWorkOrders' && newName !== 'ManualWorkOrders') {
        this.refresh();
      }
    },
  },

  mounted() {
    if (localStorage.getItem('accessTokenManu')) {
      this.refresh();
    }
  },

  methods: {
    refresh() {
      this.$store.dispatch('missingRandomNo/refresh');
    },
    goFill() {
      this.$router
        .push({ path: '/lab-orders/manual', query: { missingRandomNo: '1' } })
        .catch((e) => {
          if (e?.name !== 'NavigationDuplicated') throw e;
        });
    },
  },
};
</script>

<style scoped>
/* 모바일(<768px)에서는 고정 헤더가 사라지고 .mobile_header가 상단을 차지한다.
   배너는 main-content 내부 첫 자식이라 자연스럽게 mobile_header 아래로 흐르며,
   전체 폭을 쓰고 메시지가 길어지면 줄바꿈되도록 강제 폭 제한은 두지 않는다. */
.global-missing-randomno-banner {
  margin-bottom: 16px;
}

.global-missing-randomno-banner :deep(.ant-alert-content) {
  overflow-wrap: anywhere;
}
</style>
